import React from "react";
import { SelectItem } from "@heroui/react";
import AppSelect from "../../../../components/common/appSelect";
import { ProfileId } from "../../../../types/types";
import { FieldLabel, FieldError, selectClassNames, TranslationFn } from "../dealFormFields";

export type FighterSelectProps = {
  isGroupChat: boolean;
  selectedFighterId: ProfileId | null;
  setSelectedFighterId: React.Dispatch<React.SetStateAction<ProfileId | null>>;
  availableFighters: Array<{ id: ProfileId; firstName?: string; lastName?: string }>;
  errors: Record<string, string | undefined>;
  setErrors: React.Dispatch<React.SetStateAction<Record<string, string | undefined>>>;
  t: TranslationFn;
};

export const FighterSelect = ({
  isGroupChat,
  selectedFighterId,
  setSelectedFighterId,
  availableFighters,
  errors,
  setErrors,
  t,
}: FighterSelectProps): React.ReactElement | null => {
  if (!isGroupChat) return null;

  return (
    <div className="flex flex-col">
      <FieldLabel label={t("selectFighter")} required />

      <AppSelect
        placeholder={t("chooseFighterPlaceholder")}
        selectedKeys={
          selectedFighterId != null
            ? new Set([String(selectedFighterId)])
            : new Set()
        }
        onSelectionChange={(keys: "all" | Set<React.Key>) => {
          if (keys === "all") return;

          const selected = Array.from(keys as Set<React.Key>)[0];

          setSelectedFighterId(selected != null ? String(selected) : null);

          setErrors((prev) => ({
            ...prev,
            selectedFighterId: undefined,
          }));
        }}
        size="sm"
        variant="bordered"
        isInvalid={!!errors.selectedFighterId}
        classNames={selectClassNames}
      >
        {availableFighters.map((f) => {
          const label =
            [f.firstName, f.lastName].filter(Boolean).join(" ").trim() ||
            t("fighterNumber", { id: f.id });

          return (
            <SelectItem key={String(f.id)} textValue={label}>
              {label}
            </SelectItem>
          );
        })}
      </AppSelect>

      <FieldError error={errors.selectedFighterId} />
    </div>
  );
};
